import CripNotice from 'crip-vue-notice';
import VueI18n from '@/i18n';


export const notify = (title, description, type) => {
  const transTitle = VueI18n.t(title);
  const transDescription = VueI18n.t(description);

  // eslint-disable-next-line no-new
  new CripNotice({
    title: transTitle,
    description: transDescription,
    type: type || 'normal',
  });
};


export const pageNotFound = () => {
  notify('phrase.page_not_found', 'sentence.page_not_found', 'warning');
};
